import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";

const chipSizeSx = {
  small: {
    height: "var(--space-lg, 16px)",
    padding: "0 var(--space-xs, 4px)",
    gap: "var(--space-xs, 4px)",
  },
  medium: {
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "var(--space-sm, 8px)",
    paddingRight: "var(--space-sm, 8px)",
    gap: "var(--space-xs, 4px)",
  },
};

const sharedChipRootSx = {
  display: "inline-flex",
  width: "fit-content",
  maxWidth: "fit-content",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "var(--radius-sm, 4px)",
};

const chipRootSxByColor = {
  warning: {
    ...sharedChipRootSx,
    background: "var(--color-fill-onlight-caution-subtle, #FCF2E6)",
  },
  success: {
    ...sharedChipRootSx,
    background: "var(--color-fill-onlight-success-subtle, #E5F3E6)",
  },
};

const sharedChipLabelSx = {
  textAlign: "center",
  fontFamily: 'var(--caption-medium-font-family, "Lincoln Proxima Nova")',
  fontSize: "var(--caption-medium-font-size, 14px)",
  fontStyle: "normal",
  fontWeight: "var(--caption-medium-font-weight, 500)",
  lineHeight: "var(--caption-medium-line-height, 20px)",
  padding: 0,
};

const chipLabelSxByColor = {
  warning: {
    ...sharedChipLabelSx,
    color: "var(--chip-onlight-color-text-caution, #9F5801)",
  },
  success: {
    ...sharedChipLabelSx,
    color: "var(--chip-onlight-color-text-success, #006800)",
  },
};

const EMPChip = ({
  label,
  testId,
  labelColor = "default",
  variant = "filled",
  size = "small",
  labelFontFamily,
  sx,
}) => {
  const safeLabelColor = labelColor === "gray" ? "default" : labelColor;
  const chipRootSx = chipRootSxByColor[labelColor] || {};
  const chipLabelSx = {
    ...(chipLabelSxByColor[labelColor] || {}),
  };
  const sizeSx = chipSizeSx[size] || chipSizeSx.small;
  const labelContent = labelFontFamily ? (
    <span style={{ fontFamily: labelFontFamily }}>{label}</span>
  ) : (
    label
  );

  return (
    <Chip
      data-testid={testId}
      size="small"
      label={labelContent}
      clickable={false}
      color={safeLabelColor}
      variant={variant}
      sx={{
        ...chipRootSx,
        ...sizeSx,
        ...sx,
        "& .MuiChip-label": {
          ...chipLabelSx,
          ...sx?.["& .MuiChip-label"],
        },
      }}
    />
  );
};

EMPChip.propTypes = {
  label: PropTypes.node,
  testId: PropTypes.string,
  labelColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
    "gray",
  ]),
  variant: PropTypes.oneOf(["filled", "outlined"]),
  size: PropTypes.oneOf(["small", "medium"]),
  labelFontFamily: PropTypes.string,
  sx: PropTypes.object,
};

export default EMPChip;
